import React  from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import LegacyActionPanel from "./LegacyActionPanel";
import SearchDisplay from "./SearchDisplay";
import SelectDisplay from "./SelectDisplay";
import { panelWithActions } from "./actionPanelStyles.module.scss";

export default function SearchAndSelectionActionBar({ children, searchAction, searchValue, searchButton, selected }) {
  const usingDefaultSearch = searchAction === SearchAndSelectionActionBar.defaultProps.searchAction;

  const showSearchPanel = (!usingDefaultSearch && selected.length === 0);
  const innerPanel = (() => {
    if (showSearchPanel) {
      return (
        <SearchDisplay searchAction={searchAction} searchValue={searchValue}>
          {searchButton}
        </SearchDisplay>
      );
    } else {
      return (
        <SelectDisplay selected={selected}>{children}</SelectDisplay>
      );
    }
  })();

  return (
    <LegacyActionPanel className={classNames({ [panelWithActions]: !showSearchPanel })}>
      {innerPanel}
    </LegacyActionPanel>
  );
}

SearchAndSelectionActionBar.propTypes = {
  children: PropTypes.node,
  searchAction: PropTypes.func,
  searchButton: PropTypes.node,
  searchValue: PropTypes.string,
  selected: PropTypes.array.isRequired
};

SearchAndSelectionActionBar.defaultProps = {
  children: null,
  searchAction: () => {},
  searchValue: null,
  searchButton: null
};
